import { useEffect, useState } from "react"
import Modal from "../../../molecules/Modal"
import Input from "../../../atoms/Input"
import Select from "../../../atoms/Select"
import { toast } from "@stardust-ds/react"
import intl from "react-intl-universal"

import EditIcon from "../../../../assets/icons/EditIcon"
import Button from "../../../atoms/Button"
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import styles from "./index.module.scss"
import ClockRotateIcon from "../../../../assets/icons/ClockRotateIcon"
import RcmpLoading from "../../../atoms/Loading"
import SwitchComponent from "../../../atoms/Switch"
import RcmpTextArea from "../../../atoms/TextArea"
import { ModalInformation } from "../components/ModalInformation"
import { schema } from "../yup/schemaValidation"
import {
  createAnalitos,
  createResultOption,
  listResultOptions,
  listSectors,
  getVariableBiologic,
  createSector,
} from "../../../../services/ciq"
import { fnCanAtLeast } from "../../../../utils/permissions"
import MultiSelect from "../components/MultiSelect"

export const ModalCreateAnalito = ({ onClose, setUpdateList }) => {
  const [modalLoading, setModalLoading] = useState(false)

  const [optsResult, setOptsResults] = useState([])
  const [optsSector, setOptsSector] = useState([])

  const [isConfirmationModal, setIsConfirmationModal] = useState(false)

  const [isLoadBtn, setIsLoadBtn] = useState(false)

  const [isChecked, setChecked] = useState(true)

  const [nDecimal, setNDecimal] = useState(0)

  const [isLoading, setIsLoading] = useState(false)
  const [biologicalVariable, setBiologicalVariable] = useState([])

  const [selectType, setSelectType] = useState("")

  const types = [
    {
      label: intl.get("ciq.types_analytes.quantitative"),
      value: intl.get("ciq.types_analytes.quantitative"),
      id: 1,
    },
    {
      label: intl.get("ciq.types_analytes.qualitative"),
      value: intl.get("ciq.types_analytes.qualitative"),
      id: 2,
    },
    {
      label: intl.get("ciq.types_analytes.semmi_quantitative"),
      value: intl.get("ciq.types_analytes.semmi_quantitative"),
      id: 3,
    },
  ]

  const {
    handleSubmit,
    register,
    setValue,
    reset,
    setError,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {},
  })

  const typeMapping = {
    Quantitative: "Quantitativo",
    Qualitative: "Qualitativo",
    "Semi-Quantitative": "Semi-Quantitativo",
    Quantitativo: "Quantitativo",
    Qualitativo: "Qualitativo",
    "Semi-Quantitativo": "Semi-Quantitativo",
  }
  const transformType = (type) => {
    return typeMapping[type] || type
  }

  const submitCreateAnalitos = async (data) => {
    try {
      setIsLoading(true)
      const anlt_decimal_places = !data.anlt_decimal_places
        ? nDecimal
        : data.anlt_decimal_places

      const anlt_bstatus = !data.anlt_bstatus ? isChecked : data.anlt_bstatus

      const newData = {
        ...data,
        anlt_cname: data.anlt_cname?.trim(),
        anlt_unit_of_measure: data.anlt_unit_of_measure?.trim(),
        anlt_decimal_places,
        anlt_bstatus,
        anlt_observation: data.anlt_observation?.trim(),
        anlt_type: transformType(data.anlt_type),
      }

      // QUANTITATIVO
      if (selectType.id === 1) {
        delete newData.anlt_result_options

        await createAnalitos(newData)
        fnCloseAllModals()
        setUpdateList((oldState) => !oldState)
        return
      }

      // QUALITATIVO
      if (selectType.id === 2) {
        if (newData.anlt_result_options.length < 2) {
          return
        } else {
          delete newData.anlt_decimal_places
          // SUBMETER ANALITOS QUALITATIVO

          await createAnalitos(newData)
          fnCloseAllModals()
          setUpdateList((oldState) => !oldState)

          return
        }
      }

      // SEMI-QUANTITATIVO
      if (selectType.id === 3) {
        if (newData.anlt_result_options.length <= 1) {
          return
        } else {
          delete newData.anlt_decimal_places
          await createAnalitos(newData)
          fnCloseAllModals()
          setUpdateList((oldState) => !oldState)

          return
        }
      }
    } catch (err) {
      fnOpenToastFail(err.response?.data.message)
      console.log(err)
    } finally {
      setIsLoading(false)
    }
  }

  function fnOpenToastFail(message) {
    return toast({
      type: "error",
      title: "Erro",
      description: message,
    })
  }

  const fnCloseAllModals = () => {
    setIsConfirmationModal(false)
    onClose()
  }

  const ConfirmationModalComponent = () => {
    return (
      <>
        <div className={styles.flexCenter}>
          <p>{intl.get("ciq.question_save_changes")}</p>
        </div>
        <div className={styles.containerButton}>
          <Button
            style={{ textTransform: "capitalize" }}
            type="button"
            variant="outline"
            onClick={() => {
              setIsConfirmationModal(false)
            }}
          >
            {intl.get("back")}
          </Button>
          <Button
            style={{ textTransform: "capitalize" }}
            type="submit"
            isLoading={isLoading}
          >
            {intl.get("confirm")}
          </Button>
        </div>
      </>
    )
  }

  const fnIsError = (message) => {
    return message?.message ? styles.error : ""
  }

  const fnPermitionOnlyFiveCaracter = (e) => {
    e.target.value = e.target.value.slice(0, 5)
  }

  const postResult = async (result) => {
    try {
      setIsLoadBtn(true)
      await createResultOption({ resultopt_cdescription: result })

      await getListResultOptions()
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoadBtn(false)
    }
  }
  const postSector = async (sector_name) => {
    try {
      setIsLoadBtn(true)
      await createSector({ sector_cname: sector_name })

      await getListSectors()
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoadBtn(false)
    }
  }

  const getListResultOptions = async () => {
    try {
      const { data: dt } = await listResultOptions()

      const newData = dt.data.map((item) => ({
        label: item.resultopt_cdescription,
        value: item.resultopt_cdescription,
        resultopt_dcreated: item.resultopt_dcreated,
        resultopt_dupdated: item.resultopt_dupdated,
        id: item.resultopt_nid,
      }))

      setOptsResults(newData)
    } catch (err) {
      console.log(err)
    }
  }
  const getListSectors = async () => {
    try {
      const { data: dt } = await listSectors()

      const newData = dt.data.map((item) => ({
        label: item.sector_cname,
        value: item.sector_cname,
        sector_dcreated: item.sector_dcreated,
        sector_dupdated: item.sector_dupdated,
        id: item.sector_nid,
      }))

      setOptsSector(newData)
    } catch (err) {
      console.log(err)
    }
  }

  const getBiologicalVariationTable = async () => {
    try {
      setModalLoading(true)

      const response = await getVariableBiologic()
      setBiologicalVariable(
        response.data.data.map((item) => ({
          label: item.biological_variation_summary,
          value: item.biological_variation_summary,
          id: item.biovar_nid,
        })),
      )
    } catch (err) {
      console.log(err)
    } finally {
      setModalLoading(false)
    }
  }

  useEffect(() => {
    getListResultOptions()
    getListSectors()
  }, [selectType.value])

  useEffect(() => {
    const bAdmin = fnCanAtLeast("admin", "internal-quality-control")

    if (bAdmin || fnCanAtLeast("create-edit-analyte", "internal-quality-control")) {
      return
    } else if (
      fnCanAtLeast("create-edit-equipment", "internal-quality-control") ||
      fnCanAtLeast("create-edit-control", "internal-quality-control") ||
      fnCanAtLeast("create-edit-launch", "internal-quality-control") ||
      fnCanAtLeast("update-run", "internal-quality-control")
    ) {
      window.location.href = "/"
      return
    }
  }, [])

  useEffect(() => {
    getBiologicalVariationTable()
  }, [])

  const reserFieldForm = () => {
    setError("anlt_result_options", {
      type: "manual",
      message: "",
    })
    setError("anlt_sector_nid", {
      type: "manual",
      message: "",
    })
    setError("anlt_unit_of_measure", {
      type: "manual",
      message: "",
    })
    setError("anlt_cname", {
      type: "manual",
      message: "",
    })
    setError("anlt_type", {
      type: "manual",
      message: "",
    })
  }

  return (
    <>
      <Modal isOpen={true} size="xlg">
        <Modal.Header
          style={{
            justifyContent: "flex-start",
            padding: "0.5rem",
          }}
          onClose={() => setIsConfirmationModal(true)}
        >
          <h1 className={styles.titleModal}>
            {intl.get("ciq.list_analytes.add_exame_analyte")}
          </h1>
        </Modal.Header>

        {modalLoading ? (
          <div className={styles.flexCenter} style={{}}>
            <RcmpLoading bShow={true} />
          </div>
        ) : (
          <form
            className={styles.form}
            onSubmit={handleSubmit(submitCreateAnalitos)}
            autoComplete="off"
          >
            <Modal.Content
              size="lg"
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem",
              }}
            >
              <div className={styles.flexColumn}>
                <div className={styles.containerEditAndHistory}>
                  <span className={styles.active}>
                    <EditIcon />
                    {intl.get("edit")}
                  </span>
                  <span className={styles.desactive}>
                    <ClockRotateIcon flll="#6cb6e3" />
                    {intl.get("history")}
                  </span>
                </div>
              </div>

              {/* START OF FORM FIELDS ========================================= */}

              <div className={styles.flexLine}>
                <div style={{ width: "2.3rem" }}>
                  <Input label="ID" width="100%" disabled />
                </div>
                <div className={`${styles.itemFlex} ${fnIsError(errors?.anlt_cname)}`}>
                  <Input
                    label={intl.get("modal_form_list.name") + "*"}
                    width="100%"
                    {...register("anlt_cname")}
                    placeholder={intl.get("ciq.type_here")}
                  />

                  {fnIsError(errors?.anlt_cname) && (
                    <span>{errors?.anlt_cname?.message}</span>
                  )}
                </div>

                <div
                  style={{ width: "2rem" }}
                  className={`${styles.itemFlex} 
                    ${fnIsError(errors?.anlt_type)}
                  `}
                >
                  <Select
                    label={intl.get("ciq.header_table_list_analyte.type") + "*"}
                    options={types}
                    placeholder={intl.get("ciq.select_a_type")}
                    searchable={false}
                    width="100%"
                    className={styles.select}
                    onSelect={(e) => {
                      if (e === null) {
                        setSelectType({ label: "", value: "" })
                        return
                      }
                      setSelectType(e)
                      setValue("anlt_type", e.label)

                      reserFieldForm()
                      if (e.id === 1) {
                        setValue("anlt_result_options", [1, 2, 3, 4])
                      }
                    }}
                  />

                  {fnIsError(errors?.anlt_type) && (
                    <span>{errors?.anlt_type?.message}</span>
                  )}
                </div>

                <div className={styles.containerSwitch}>
                  <label>{intl.get("modal_form_list.status")}</label>
                  <SwitchComponent
                    width="10rem"
                    label={intl.get("modal_form_list.status")}
                    onClick={() => {
                      setChecked((oldState) => !oldState)
                      setValue("anlt_bstatus", !isChecked)
                    }}
                    cDisabledText={intl.get("ciq.inactive_up")}
                    cAbleText={intl.get("ciq.active_up")}
                    value={isChecked}
                  />
                </div>
              </div>

              {/* QUANTITATIVO ========================= */}

              {selectType.id === 1 && (
                <div className={styles.flexColumn}>
                  <div className={styles.flexLine}>
                    <div
                      className={`${styles.itemFlex} 
                        ${fnIsError(errors?.anlt_unit_of_measure)}
                     `}
                    >
                      <Input
                        label={intl.get("ciq.create_analytes.unit") + "*"}
                        width="100%"
                        {...register("anlt_unit_of_measure")}
                        // onChange={fnPermitionOnlyFiveCaracter}
                        placeholder={intl.get("ciq.type_here")}
                      />
                      {fnIsError(errors?.anlt_unit_of_measure) && (
                        <span>{errors?.anlt_unit_of_measure?.message}</span>
                      )}
                    </div>
                    {/* componente setor */}
                    <div style={{ zIndex: 99999, width: "35%" }}>
                      <MultiSelect
                        width="100%"
                        label={intl.get("ciq.header_table_list_analyte.sector") + "*"}
                        placeholder={intl.get("ciq.select_one_sector")}
                        limitOptsSelected={1}
                        onSelect={(e) => {
                          setValue("anlt_sector_nid", e.map((item) => item.id)[0])
                        }}
                        opts={optsSector}
                        isError={fnIsError(errors?.anlt_sector_nid)}
                        messageError={errors?.anlt_sector_nid?.message}
                        onCreateOption={postSector}
                        isloading={isLoadBtn}
                        type="sector"
                      />
                    </div>
                    <div
                      className={`${styles.itemFlex} ${fnIsError(errors?.anlt_cname)}`}
                    >
                      <Input
                        isFullWidth
                        type="number"
                        label={intl.get("ciq.modal_create_analytos.fields.ndecimals")}
                        min={0}
                        max={5}
                        defaultValue={0}
                        value={nDecimal}
                        onChange={(e) => {
                          setNDecimal(e)
                          setValue("anlt_decimal_places", e)
                        }}
                      />
                      {fnIsError(errors?.anlt_decimal_places) && (
                        <span>{errors?.anlt_decimal_places?.message}</span>
                      )}
                    </div>
                  </div>

                  {/* TABELA DE VARIAÇÃO BIOLÓGICA */}
                  <div className={styles.equipmentContaner}>
                    <MultiSelect
                      label={intl.get("ciq.header_table_list_analyte.variation_biologic")}
                      placeholder={intl.get("selection")}
                      limitOptsSelected={1}
                      onSelect={(e) => {
                        setValue("anlt_biovar_nid", e.map((item) => item.id)[0] || null)
                      }}
                      opts={biologicalVariable}
                      type="sector"
                      bIsEdit={true}
                      bInactiveBtn
                    />
                  </div>

                  <RcmpTextArea
                    className={`${styles.itemFlex}`}
                    label={intl.get("ciq.observation")}
                    {...register("anlt_observation")}
                    placeholder={intl.get("ciq.type_here")}
                  />
                </div>
              )}

              {/* QUALITATIVO ====================================== */}
              {selectType.id === 2 && (
                <div className={styles.flexColumn} style={{ gap: "1rem 0.5rem" }}>
                  <div className={styles.flexLine} style={{ zIndex: 9999 }}>
                    <MultiSelect
                      width="100%"
                      label={intl.get("ciq.header_table_list_analyte.sector") + "*"}
                      placeholder={intl.get("ciq.select_one_sector")}
                      limitOptsSelected={1}
                      onSelect={(e) => {
                        setValue("anlt_sector_nid", e.map((item) => item.id)[0])
                      }}
                      opts={optsSector}
                      isError={fnIsError(errors?.anlt_sector_nid)}
                      messageError={errors?.anlt_sector_nid?.message}
                      onCreateOption={postSector}
                      isloading={isLoadBtn}
                      type="sector"
                    />
                  </div>

                  <MultiSelect
                    label={intl.get("ciq.opt_results") + "*"}
                    placeholder={intl.get("ciq.select_two_opts")}
                    onSelect={(e) => {
                      setValue(
                        "anlt_result_options",
                        e.map((item) => item.id),
                      )
                    }}
                    opts={optsResult}
                    isError={fnIsError(errors?.anlt_result_options)}
                    messageError={errors?.anlt_result_options?.message}
                    onCreateOption={postResult}
                    isloading={isLoadBtn}
                    type="semi-quantitativo"
                  />

                  <RcmpTextArea
                    placeholder={intl.get("ciq.type_here")}
                    className={`${styles.itemFlex}`}
                    label={intl.get("ciq.observation")}
                    {...register("anlt_observation")}
                  />
                </div>
              )}

              {/* Semi-Quantitativo ====================================== */}
              {selectType.id === 3 && (
                <div className={styles.flexColumn} style={{ gap: "1rem 0.5rem" }}>
                  <div className={styles.flexLine} style={{ zIndex: 99999 }}>
                    <MultiSelect
                      width="100%"
                      label={intl.get("ciq.header_table_list_analyte.sector") + "*"}
                      placeholder={intl.get("ciq.select_one_sector")}
                      limitOptsSelected={1}
                      onSelect={(e) => {
                        setValue("anlt_sector_nid", e.map((item) => item.id)[0])
                      }}
                      opts={optsSector}
                      isError={fnIsError(errors?.anlt_sector_nid)}
                      messageError={errors?.anlt_sector_nid?.message}
                      onCreateOption={postSector}
                      isloading={isLoadBtn}
                      type="sector"
                    />
                  </div>

                  <MultiSelect
                    label={intl.get("ciq.opt_results") + "*"}
                    placeholder={intl.get("ciq.select_two_opts")}
                    onSelect={(e) => {
                      setValue(
                        "anlt_result_options",
                        e.map((item) => item.id),
                      )
                    }}
                    opts={optsResult}
                    isError={fnIsError(errors?.anlt_result_options)}
                    messageError={errors?.anlt_result_options?.message}
                    onCreateOption={postResult}
                    isloading={isLoadBtn}
                    type="semi-quantitativo"
                  />

                  <RcmpTextArea
                    placeholder={intl.get("ciq.type_here")}
                    className={`${styles.itemFlex}`}
                    label={intl.get("ciq.observation")}
                    {...register("anlt_observation")}
                  />
                </div>
              )}

              <div className={styles.containerButton}>
                <Button
                  type="button"
                  variant="outline"
                  onClick={() => setIsConfirmationModal(true)}
                >
                  {intl.get("cancel")}
                </Button>
                <Button
                  style={{ textTransform: "uppercase" }}
                  type="submit"
                  isLoading={isLoading}
                >
                  {intl.get("ciq.btn_save")}
                </Button>
              </div>
            </Modal.Content>
            {/* // )} */}
          </form>
        )}

        {isConfirmationModal && (
          <ModalInformation
            bgBtn="#1ECB4F"
            title={intl.get("ciq.register_analyte")}
            description={intl.get("ciq.changes_not_save")}
            onCancel={() => setIsConfirmationModal(false)}
            onClose={() => {
              fnCloseAllModals()
            }}
          />
        )}
      </Modal>
    </>
  )
}
